module.exports = __webpack_public_path__ + "plat/static/img/task.7566dbab.svg";